<template>
	<div
		class="bg-fill-tertiary sticky right-0 bottom-0 left-0 shrink-0 px-4"
		:class="{
			'border-t border-black': !borderless
		}"
		style="padding-bottom: max(var(--padding-bottom), 1rem)"
	>
		<slot />
	</div>
</template>
<script setup lang="ts">
defineProps<{
	borderless?: boolean
}>()
</script>
